(function () {
  if (window.__idasMegaMenuInit) return;
  window.__idasMegaMenuInit = true;

  function closeOtherMobileSubmenus(activeInput) {
    document.querySelectorAll('#mobile-header.hb-customizer .mobile-menu__first-level > .submenu__input').forEach(function (input) {
      if (input !== activeInput) input.checked = false;
    });
  }

  document.addEventListener('click', function (event) {
    var backButton = event.target.closest('[data-idas-mega-menu-back], [data-idas-mobile-submenu-back]');
    if (!backButton) return;

    event.preventDefault();

    var firstLevel = backButton.closest('.mobile-menu__first-level');
    if (!firstLevel) return;

    var submenuInput = firstLevel.querySelector('.submenu__input');
    if (submenuInput) submenuInput.checked = false;
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('#mobile-header.hb-customizer .mobile-menu__first-level > .submenu__input')) return;

    if (input.checked) closeOtherMobileSubmenus(input);
  });

  document.addEventListener('click', function (event) {
    var firstLevel = event.target.closest('#mobile-header.hb-customizer .mobile-menu__first-level.has-submenu, #mobile-header.hb-customizer .mobile-menu__first-level[data-mobile-menu-has-toggle="true"]');
    if (!firstLevel) return;
    if (event.target.closest('.mobile-menu__submenu')) return;
    if (event.target.closest('[data-idas-mega-menu-back], [data-idas-mobile-submenu-back]')) return;

    var link = event.target.closest('a[href]');
    if (!link || !firstLevel.contains(link)) return;

    event.preventDefault();
  }, true);
})();
